export const TaskStatus = {
    PLANNED:/*     */ { uuid: '08a15c20-9496-44ee-a186-33d811c1ded0', color: 'white', background: '#e82024', name: 'Запланировано',/* */summary: 'Запланированная заявка' },
    IN_PROGRESS:/* */ { uuid: 'ae136aba-56ca-48aa-a0b3-a969533d3b99', color: 'white', background: '#f3bb1c', name: 'В работе',/*      */summary: 'Заявка в работе' },
    PAUSED:/*      */ { uuid: '726a31ba-9a43-11ec-8685-c4346bb7a003', color: 'white', background: '#00ABCD', name: 'Пауза',/*         */summary: 'Заявка на паузе' },
    DONE:/*        */ { uuid: '556cc013-2a23-4a31-826f-adeb6ae8c59a', color: 'white', background: '#3cc13b', name: 'Завершено',/*     */summary: 'Заявка закрыта' },
    CANCELED:/*    */ { uuid: '4652dcb1-b68f-451c-9693-26f2233fcb48', color: 'white', background: '#828282', name: 'Отменено',/*      */summary: 'Заявка отменена' },
}

export const taskColorByUUID = (uuid) => {
    const taskStatus = Object.values(TaskStatus).find(status => status.uuid === uuid);
    return taskStatus ? taskStatus.background : '#828282'; // Default to gray if not found
}

export const matchStatusByName = (name) => {
    const status = Object.values(TaskStatus).find(status => status.name === name);
    return status ? status : TaskStatus.PLANNED; // Default to PLANNED if not found
}